/* Vitalia — page produit.
   Galerie, offres, accordéons, onglets FAQ, avis, barre d'achat fixe.
   Le thème Horizon fait défiler .page-wrapper et non la fenêtre : on cherche
   le vrai conteneur de défilement avant de mesurer quoi que ce soit. */
(function () {
  'use strict';
  if (window.__vpInit) return;
  window.__vpInit = true;

  var scroller = null;

  function findScroller() {
    var el = document.querySelector('.page-wrapper');
    if (el && el.scrollHeight > el.clientHeight + 1) {
      var ov = getComputedStyle(el).overflowY;
      if (ov === 'auto' || ov === 'scroll') return el;
    }
    return null;
  }
  function sy() {
    return scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
  }
  function vh() {
    return scroller ? scroller.clientHeight : window.innerHeight;
  }

  /* ------------------------------------------------------------ galerie -- */
  function initGallery(root) {
    var galleries = root.querySelectorAll('[data-vp-gallery]');
    Array.prototype.forEach.call(galleries, function (g) {
      if (g.__vp) return;
      g.__vp = true;
      var track = g.querySelector('[data-vp-track]');
      var slides = track ? track.children : [];
      var thumbs = g.querySelectorAll('[data-vp-thumb]');
      var i = 0;
      if (!track || !slides.length) return;

      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        Array.prototype.forEach.call(thumbs, function (t, k) {
          t.classList.toggle('is-active', k === i);
        });
        var active = thumbs[i];
        if (active && active.parentNode && active.parentNode.scrollWidth > active.parentNode.clientWidth) {
          active.parentNode.scrollTo({ left: active.offsetLeft - 20, behavior: 'smooth' });
        }
      }
      g.__vpGo = go;

      Array.prototype.forEach.call(thumbs, function (t, k) {
        t.addEventListener('click', function () { go(k); });
      });
      var next = g.querySelector('[data-vp-next]');
      var prev = g.querySelector('[data-vp-prev]');
      if (next) next.addEventListener('click', function () { go(i + 1); });
      if (prev) prev.addEventListener('click', function () { go(i - 1); });

      /* glissement tactile */
      var x0 = null;
      g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 42) go(i + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });

      go(0);
    });
  }

  /* ------------------------------------------------------------- offres -- */
  function money(cents, format) {
    var v = (cents / 100);
    var s = v.toLocaleString('fr-FR', {
      minimumFractionDigits: v % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return (format || 'DA {}').replace('{}', s);
  }

  function initOffers(root) {
    var boxes = root.querySelectorAll('[data-vp-offers]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.__vp) return;
      box.__vp = true;
      var formId = box.getAttribute('data-form');
      var inputs = box.querySelectorAll('input[type="radio"]');

      function apply(input) {
        if (!input) return;
        var form = formId ? document.getElementById(formId) : null;
        if (form) {
          var idField = form.querySelector('[name="id"]');
          var qtyField = form.querySelector('[name="quantity"]');
          var packField = form.querySelector('[data-vp-pack]');
          if (idField && input.dataset.variant) idField.value = input.dataset.variant;
          if (qtyField && input.dataset.qty) qtyField.value = input.dataset.qty;
          if (packField) packField.value = input.dataset.pack || '';
        }
        /* prix repris dans la barre fixe */
        var label = input.dataset.price || '';
        var targets = document.querySelectorAll('[data-vp-live-price]');
        Array.prototype.forEach.call(targets, function (t) { if (label) t.textContent = label; });
      }

      Array.prototype.forEach.call(inputs, function (input) {
        input.addEventListener('change', function () { apply(input); });
        if (input.checked) apply(input);
      });
    });
  }

  /* -------------------------------------------------------- accordéons -- */
  function initAccordions(root) {
    var heads = root.querySelectorAll('[data-vp-acc]');
    Array.prototype.forEach.call(heads, function (h) {
      if (h.__vp) return;
      h.__vp = true;
      h.addEventListener('click', function () {
        var item = h.closest('.vp-acc__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------ onglets FAQ --- */
  function initTabs(root) {
    var groups = root.querySelectorAll('[data-vp-tabs]');
    Array.prototype.forEach.call(groups, function (g) {
      if (g.__vp) return;
      g.__vp = true;
      var tabs = g.querySelectorAll('[data-vp-tab]');
      Array.prototype.forEach.call(tabs, function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-vp-tab');
          Array.prototype.forEach.call(tabs, function (o) {
            o.classList.toggle('is-active', o === t);
            o.setAttribute('aria-selected', o === t ? 'true' : 'false');
          });
          var panels = g.querySelectorAll('[data-vp-panel]');
          Array.prototype.forEach.call(panels, function (p) {
            p.hidden = p.getAttribute('data-vp-panel') !== key;
          });
        });
      });
    });
  }

  /* -------------------------------------------------------- voir plus --- */
  function initMore(root) {
    var buttons = root.querySelectorAll('[data-vp-more]');
    Array.prototype.forEach.call(buttons, function (b) {
      if (b.__vp) return;
      b.__vp = true;
      b.addEventListener('click', function () {
        var sel = b.getAttribute('data-vp-more');
        var hidden = document.querySelectorAll(sel + ' [hidden]');
        var n = parseInt(b.getAttribute('data-vp-step') || '4', 10);
        Array.prototype.forEach.call(hidden, function (el, k) {
          if (k < n) el.hidden = false;
        });
        if (hidden.length <= n) b.hidden = true;
      });
    });
  }

  /* --------------------------------------------------- barre d'achat ---- */
  var stickyBar = null;
  var stickyAnchor = null;

  function initSticky(root) {
    stickyBar = root.querySelector('[data-vp-sticky]');
    stickyAnchor = document.querySelector('[data-vp-sticky-after]');
    if (stickyBar) onScroll();
  }

  function onScroll() {
    if (stickyBar) {
      var show = false;
      if (stickyAnchor) {
        var r = stickyAnchor.getBoundingClientRect();
        show = r.bottom < 0;
      } else {
        show = sy() > vh() * 0.8;
      }
      stickyBar.classList.toggle('is-on', show);
    }
    reveal();
  }

  /* ---------------------------------------------------------- apparition */
  var revealEls = [];
  function initReveal(root) {
    revealEls = Array.prototype.slice.call(root.querySelectorAll('[data-vp-reveal]'));
    revealEls.forEach(function (el) { el.classList.add('vp-reveal'); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      revealEls.forEach(function (el) { io.observe(el); });
      revealEls = [];
    } else {
      reveal();
    }
  }
  function reveal() {
    if (!revealEls.length) return;
    var h = vh();
    revealEls = revealEls.filter(function (el) {
      if (el.getBoundingClientRect().top < h * 0.92) { el.classList.add('is-in'); return false; }
      return true;
    });
  }

  /* ------------------------------------------------------------ dates --- */
  function initDates(root) {
    var els = root.querySelectorAll('[data-vp-date]');
    var fmt = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit' });
    Array.prototype.forEach.call(els, function (el) {
      var days = parseInt(el.getAttribute('data-vp-date'), 10);
      if (isNaN(days)) return;
      var d = new Date();
      d.setDate(d.getDate() + days);
      el.textContent = fmt.format(d);
    });
  }

  /* ------------------------------------------------- lecteur vidéo ----- */
  var openVid = null;

  function lockScroll(on) {
    var el = scroller || document.documentElement;
    el.style.overflow = on ? 'hidden' : '';
  }

  function closeVid() {
    if (!openVid) return;
    var m = openVid;
    openVid = null;
    m.hidden = true;
    var v = m.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    var host = m.querySelector('[data-vp-embed]');
    if (host) host.innerHTML = '';
    lockScroll(false);
  }

  function showVid(m) {
    if (!m) return;
    closeVid();
    m.hidden = false;
    openVid = m;
    lockScroll(true);

    var host = m.querySelector('[data-vp-embed]');
    if (host && !host.firstChild) {
      var type = host.getAttribute('data-type');
      var id = host.getAttribute('data-id');
      var src = type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0'
        : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      var f = document.createElement('iframe');
      f.setAttribute('src', src);
      f.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', 'allowfullscreen');
      f.setAttribute('title', 'Vidéo');
      host.appendChild(f);
    }

    var v = m.querySelector('video');
    if (v) { try { v.play(); } catch (e) {} }

    var close = m.querySelector('[data-vp-vid-close]');
    if (close) close.focus();
  }

  function initVideos(root) {
    var buttons = root.querySelectorAll('[data-vp-story]');
    Array.prototype.forEach.call(buttons, function (b) {
      if (b.__vp) return;
      b.__vp = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        showVid(document.getElementById(b.getAttribute('data-vp-story')));
      });
    });

    var closers = root.querySelectorAll('[data-vp-vid-close]');
    Array.prototype.forEach.call(closers, function (c) {
      if (c.__vp) return;
      c.__vp = true;
      c.addEventListener('click', closeVid);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeVid();
  });

  /* ------------------------------------------------------------- boot --- */
  function boot() {
    scroller = findScroller();
    var root = document;
    initGallery(root);
    initOffers(root);
    initAccordions(root);
    initTabs(root);
    initMore(root);
    initDates(root);
    initVideos(root);
    initReveal(root);
    initSticky(root);
    onScroll();
  }

  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', function () { scroller = findScroller(); onScroll(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme Editor : on relance après chaque rechargement de section. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 30);
  });
})();
